import { radiusCva, useProvider } from "@overmap-ai/blocks"
import { cx } from "class-variance-authority"
import { memo, type PropsWithChildren } from "react"
import { twMerge } from "tailwind-merge"

import { Map } from "../../mapbox/components/Map"
import { MapStyle } from "../../mapbox/enums"
import { useAppSelector } from "../../store"
import { selectAppearance } from "../../store/selectors"

export const MapBackgroundContainer = memo<PropsWithChildren>((props) => {
	const { children } = props
	const appearance = useAppSelector(selectAppearance)
	const { radius } = useProvider()

	return (
		<div className="absolute inset-0 flex flex-col">
			<Map zoom={2} mapStyle={appearance === "dark" ? MapStyle.DARK : MapStyle.LIGHT}>
				<div
					className={twMerge(
						cx(
							"w-sm bg-(--color-background) ring-(--base-a6) pointer-events-auto relative left-1/2 top-1/2 flex -translate-x-1/2 -translate-y-1/2 flex-col overflow-hidden shadow-md ring",
							radiusCva({ radius, maxLarge: true }),
						),
					)}
				>
					{children}
				</div>
			</Map>
		</div>
	)
})
MapBackgroundContainer.displayName = "MapBackgroundContainer"
